import BackButton from './BackButton';

export default BackButton;



// WEBPACK FOOTER //
// ./src/client/Components/BackButton/index.js